"use client"

import type { ReactNode } from "react"
import { useViewport } from "@/contexts/viewport-context"

interface PillarboxLayoutProps {
  children: ReactNode
}

export function PillarboxLayout({ children }: PillarboxLayoutProps) {
  const { isPillarboxed, pillarWidth, gameWidth } = useViewport()

  // On mobile or portrait, render children directly
  if (!isPillarboxed) {
    return (
      <div id="game-viewport-mobile" className="fixed inset-0 overflow-hidden">
        {children}
      </div>
    )
  }

  // On desktop landscape, render with pillarbox
  return (
    <div id="pillarbox-container" className="fixed inset-0 flex bg-black">
      {/* Left pillar */}
      <div id="pillarbox-left" className="h-full flex-shrink-0 overflow-hidden" style={{ width: pillarWidth }}>
        <img
          src="/images/l-pillarbox.png"
          alt=""
          className="h-full object-cover"
          style={{
            imageRendering: "pixelated",
            marginLeft: "auto",
            display: "block",
          }}
        />
      </div>

      {/* Game container - portrait aspect ratio */}
      <div
        id="game-viewport-desktop"
        className="h-full flex-shrink-0 relative overflow-hidden"
        style={{ width: gameWidth }}
      >
        {children}
      </div>

      {/* Right pillar */}
      <div id="pillarbox-right" className="h-full flex-shrink-0 overflow-hidden" style={{ width: pillarWidth }}>
        <img
          src="/images/r-pillarbox.png"
          alt=""
          className="h-full object-cover"
          style={{
            imageRendering: "pixelated",
            marginRight: "auto",
            display: "block",
          }}
        />
      </div>
    </div>
  )
}
